export function distanceBetween(a, b) {
    if (!a || !b) {
        return 0;
    }
    return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
}
